<template>
  <button
      type="button"
      role="switch"
      class="custom-toggle"
      :class="{ 'is-active': value }"
      :aria-checked="String(value)"
      :aria-label="label"
      :disabled="disabled"
      @click="$emit('input', !value)"
  >
    <span class="custom-toggle-copy">
      <span class="custom-toggle-label">{{ label }}</span>
      <span v-if="description" class="custom-toggle-description">{{ description }}</span>
    </span>
    <span class="custom-toggle-track" aria-hidden="true"></span>
  </button>
</template>

<script>
export default {
  name: 'CustomSwitch',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, required: true },
    description: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.custom-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: start;
  cursor: pointer;
}
.custom-toggle-copy { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.custom-toggle-label { font-weight: 600; line-height: 1.6; }
.custom-toggle-description { font-size: .8rem; line-height: 1.7; opacity: .75; }
.custom-toggle-track {
  position: relative;
  flex: 0 0 44px;
  width: 44px;
  height: 26px;
  border-radius: 20px;
  background: #b9b9c3;
  transition: background .2s;
}
.custom-toggle-track::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .15);
  transition: transform .2s;
}
.is-active .custom-toggle-track { background: var(--primary, #7367f0); }
.is-active .custom-toggle-track::after { transform: translateX(18px); }
.custom-toggle:focus-visible { outline: 2px solid var(--primary, #7367f0); outline-offset: 6px; border-radius: 4px; }
.custom-toggle:disabled { opacity: .6; cursor: not-allowed; }
@media (prefers-reduced-motion: reduce) {
  .custom-toggle-track, .custom-toggle-track::after { transition: none; }
}
</style>
